<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
<!--            <el-tab-pane label="OKR排行" name="0">-->
<!--                <okrBank :sectionClassId="16"></okrBank>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="OKR查看" name="0">-->
<!--                <okrList :sectionClassId="17"></okrList>-->
<!--            </el-tab-pane>-->

            <el-tab-pane label="KR" name="0">
                <krForm :sectionClassId="17"></krForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法

    import krForm from "@/components/cooperative/krForm";
    //定义组件
    export default {
        data() {
            return {
                activeName:'0'
            }
        },
        components:{
            krForm,

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/KR.vue